import React from "react";
import { AdminStore } from "./AdminStore";
import { CurrentUserStore } from "./CurrentUserStore";
import { ReportsStore } from "./ReportsStore";

const Stores: React.FC = props => (
    <CurrentUserStore>
        <ReportsStore>
            <AdminStore>
                {props.children}
            </AdminStore>
        </ReportsStore>
    </CurrentUserStore>
);

export default Stores;
